import minus from '@/assets/images/minus.svg';
import plus from '@/assets/images/plus.svg';
import styles from './IncreaseDecreaseNumber.module.scss';

interface Props {
  value: number;
  minValue?: number;
  maxValue?: number;
  onChange: (value: number) => void;
  label?: string;
  disabled?: boolean;
  testIdSuffix?: string;
  dataTestId?: string;
}

export const IncreaseDecreaseNumber = ({
  value,
  minValue = 1,
  maxValue = 100,
  onChange,
  label,
  disabled,
  testIdSuffix,
  dataTestId,
}: Props) => {
  const handleDecrease = () => {
    if (disabled) return;
    if (value > minValue) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (disabled) return;
    if (value < maxValue) {
      onChange(value + 1);
    }
  };

  return (
    <div className={styles.container} data-testid={dataTestId}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.control}>
        <button
          className={styles.button}
          onClick={handleDecrease}
          disabled={disabled || value <= minValue}
          aria-label="Decrease"
          data-testid={testIdSuffix ? `decrease-button-${testIdSuffix}` : 'decrease-button'}
        >
          <img src={minus} alt="Minus" />
        </button>
        <span className={styles.value}>{value}</span>
        <button
          className={styles.button}
          onClick={handleIncrease}
          disabled={disabled || value >= maxValue}
          aria-label="Increase"
          data-testid={testIdSuffix ? `increase-button-${testIdSuffix}` : 'increase-button'}
        >
          <img src={plus} alt="Plus" />
        </button>
      </div>
    </div>
  );
};
